import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useImperativeHandle,
  forwardRef,
} from "react";
import "./autocompleteGo.css";
import { IoMdClose } from "react-icons/io";

const AutocompleteGo = forwardRef(
  (
    {
      onChange,
      value,
      options,
      onInputChanged,
      onInputLiveChange,
      placeholder = "Escribe...",
      readOnly = false,
      liveMode = false,
      showEvenIfNoMatch = false,
      style,
      children,
      ...props
    },
    ref,
  ) => {
    const RESET_CURRENT_FOCUS_INDEX = -1;

    const inputRef = useRef();
    const currentFocus = useRef(RESET_CURRENT_FOCUS_INDEX);
    const [showClearButton, setShowClearButton] = useState(false);
    const [filteredItems, setFilteredItems] = useState([]);
    //const [optionList, setOptionList] = useState([]);
    const optionListRef = useRef([]);

    const selectValue = useCallback(
      (item) => {
        inputRef.current.value = item == null ? "" : item.value;
        onChange && onChange(item);
      },
      [onChange],
    );

    const onInputValueChanged = useCallback(
      (value) => {
        inputRef.current.value = value;
        onInputChanged && onInputChanged(value);
      },
      [onInputChanged],
    );

    useImperativeHandle(ref, () => ({
      clearInput: () => {
        clearInput();
      },
      clearInputOnly: () => {
        clearInputOnly();
      },
    }));

    function clearInput() {
      setShowClearButton(false);
      inputRef.current.value = "";
      inputRef.current.focus();

      selectValue(null);
    }

    function clearInputOnly() {
      setShowClearButton(false);
      inputRef.current.value = "";
      inputRef.current.focus();
    }

    ////
    const onClick = (e) => {
      //let val = this.value;
      e.stopPropagation();

      console.log("===> CLICK CLOSE X");

      /*  e.stopImmediatePropagation();
      e.preventDefault();
      e.stopPropagation();
*/
      const val = e.target.value;

      updateCompletionList(val);
      //  onInputValueChanged(val);
    };
    const onInput = (e) => {
      //let val = this.value;
      const val = e.target.value;

      /*  e.stopImmediatePropagation();
      e.preventDefault();
      e.stopPropagation();*/

      console.log(val);

      if (val.length === 0) {
        return;
      }

      if (!liveMode) {
        updateCompletionList(val);
      }

      onInputValueChanged(val);
    };
    const onKeydown = (e) => {
      //var x = document.getElementById(this.id + "autocomplete-list");
      let x = document.getElementById("input-autocomplete-list");
      if (!x) return;

      if (x) x = x.getElementsByTagName("li");
      if (e.keyCode === 40) {
        /*If the arrow DOWN key is pressed,
        increase the currentFocus variable:*/
        currentFocus.current++;
        /*and and make the current item more visible:*/
        addActive(x);
      } else if (e.keyCode === 38) {
        //up
        /*If the arrow UP key is pressed,
        decrease the currentFocus variable:*/
        currentFocus.current--;
        /*and and make the current item more visible:*/
        addActive(x);
      } else if (e.keyCode === 13) {
        /*If the ENTER key is pressed, prevent the form from being submitted,*/
        e.preventDefault();
        if (currentFocus.current > RESET_CURRENT_FOCUS_INDEX) {
          /*and simulate a click on the "active" item:*/
          if (x) x[currentFocus.current].click();
          document.activeElement.blur();
          closeList();
        }
      }
    };

    function addActive(x) {
      /*a function to classify an item as "active":*/
      if (!x) return false;
      /*start by removing the "active" class on all items:*/
      removeActive(x);
      if (currentFocus.current >= x.length) currentFocus.current = 0;
      if (currentFocus.current < 0) currentFocus.current = x.length - 1;
      /*add class "autocomplete-active":*/
      x[currentFocus.current].classList.add("autocomplete-active");
      scrollIntoViewIfNeeded(x[currentFocus.current]);
    }

    function removeActive(x) {
      /*a function to remove the "active" class from all autocomplete items:*/
      for (var i = 0; i < x.length; i++) {
        x[i].classList.remove("autocomplete-active");
      }
    }

    function closeList() {
      setFilteredItems([]);
      document.removeEventListener("click", closeList);
    }

    function clickCloseList(e) {
      //  document.removeEventListener("click", closeList);
      e.stopPropagation();

      console.log("--> CLICK CLOSE");
      closeList();
    }

    function updateCompletionList(val, shouldOpenIfClosed = true) {
      /*close any already open lists of autocompleted values*/
      if (filteredItems.length === 0) closeList();

      setShowClearButton(val.length > 0);
      /* esta vacio el input, MUESTRA NADA if (!val) {
        return false;
      }*/
      currentFocus.current = RESET_CURRENT_FOCUS_INDEX;

      /*for each item in the array...*/
      var reduced = optionListRef.current.reduce(function (
        filtered,
        option,
        index,
      ) {
        //option.substring(0, val.length).toUpperCase() === val.toUpperCase()
        /*  const foundIndex = option.toUpperCase().indexOf(val.toUpperCase());
      if (foundIndex === -1) {
        return filtered;
      }*/

        const optionName = option.nombre;
        const optionId = option.id;
        const enabled = option.enabled ?? true;
        const optionUpcase = optionName.toUpperCase();
        const valUpcase = val.toUpperCase();

        const words = [];
        let nextPos = 0;
        //while(true){
        const foundIndex = optionUpcase.indexOf(valUpcase, nextPos);
        if (foundIndex !== RESET_CURRENT_FOCUS_INDEX) {
          const first = optionName.substring(nextPos, foundIndex);
          words.push({ text: first, isBold: false });

          nextPos = foundIndex + val.length;
          const boldText = optionName.substring(foundIndex, nextPos);
          words.push({ text: boldText, isBold: true });

          const end = optionName.substring(nextPos, optionName.length);
          words.push({ text: end, isBold: false });
        } else {
          if (!showEvenIfNoMatch) {
            return filtered;
          }
          // nothing to bold, show all as normal
          words.push({ text: optionName, isBold: false });
        }

        const newItem = {
          id: optionId,
          value: optionName,
          words: words,
          //  bold: option.substring(0, foundIndex),
          //normal: option.substring(foundIndex, val.length - foundIndex),
          option,
          enabled,
        };
        filtered.push(newItem);

        return filtered;
      }, []);

      if (reduced.length > 0) {
        document.addEventListener("click", clickCloseList, { once: true });
        setFilteredItems(reduced);
      }
      //setShowAutocomplete(true);
    }

    /**
     * Method to scroll into view port, if it's outside the viewport
     *
     * @param {Object} target - DOM Element
     * @returns {undefined}
     */
    const scrollIntoViewIfNeeded = (target) => {
      let autoCompleteContainer = document.getElementById(
        "input-autocomplete-list",
      );
      // Target is outside the viewport from the bottom
      if (
        target.getBoundingClientRect().bottom >
        autoCompleteContainer.clientHeight
      ) {
        //  The bottom of the target will be aligned to the bottom of the visible area of the scrollable ancestor.
        target.scrollIntoView(false);
      }

      // Target is outside the view from the top
      if (target.getBoundingClientRect().top < 0) {
        // The top of the target will be aligned to the top of the visible area of the scrollable ancestor
        target.scrollIntoView();
      }
    };

    //

    const autocomplete = (arr, shouldOpenIfClosed = true) => {
      optionListRef.current = arr;
      /*the autocomplete function takes two arguments,
        the text field element and an array of possible autocompleted values:*/

      updateCompletionList(inputRef.current.value, shouldOpenIfClosed);
    };

    function addEventListeners() {
      if (inputRef.current == null) return;
      inputRef.current.addEventListener("click", onClick);

      /*execute a function when someone writes in the text field:*/
      inputRef.current.addEventListener("input", onInput);

      /*execute a function presses a key on the keyboard:*/
      inputRef.current.addEventListener("keydown", onKeydown);
    }

    function removeEventListeners() {
      if (inputRef.current == null) return;
      inputRef.current.removeEventListener("click", onClick);

      /*execute a function when someone writes in the text field:*/
      inputRef.current.removeEventListener("input", onInput);

      /*execute a function presses a key on the keyboard:*/
      inputRef.current.removeEventListener("keydown", onKeydown);
    }

    useEffect(() => {
      /*initiate the autocomplete function on the "myInput" element, and pass along the countries array as possible autocomplete values:*/

      console.log("--> Autocomplete");
      console.log("--> INPUT: " + inputRef.current.value);

      inputRef.current.value = value ?? "";

      addEventListeners();

      autocomplete(options);
      closeList();

      return () => {
        removeEventListeners();
      };
    }, []);

    useEffect(() => {
      autocomplete(options, false);
      if (document.activeElement !== inputRef.current) {
        closeList();
      }
      if (!liveMode) {
        refreshInputValue();
      }
    }, [options]);

    useEffect(() => {
      //  autocomplete(inputRef.current, options);
      console.log(`..NEW VALUE: ${value}`);

      refreshInputValue();
    }, [value]);

    function refreshInputValue() {
      let text = "";
      const item = options?.find((item) => item.id === value);
      if (item) {
        text = item == null ? "" : item.nombre;
      }

      if (liveMode) {
        text = inputRef.current.value;
      } else {
        inputRef.current.value = text;
      }

      setShowClearButton(text.length > 0);
    }

    return (
      <>
        <div className="suggestion-container" style={style}>
          <div className="form-group has-feedback has-clear parent-input">
            <input
              type="text"
              className="form-control"
              placeholder={placeholder}
              style={{ backgroundImage: "none" }}
              {...props}
              ref={inputRef}
              autoComplete="off"
              readOnly={readOnly}
            />
            {children}
            <span
              onClick={(e) => {
                clearInput();
              }}
              className={`form-control-clear glyphicon glyphicon-remove form-control-feedback ${
                showClearButton && !readOnly ? "" : "hideButton"
              }`}
            >
              <IoMdClose />
            </span>
          </div>
          {filteredItems.length > 0 && (
            <div className="autocomplete-of" style={{ width: "100%" }}>
              <ul id="input-autocomplete-list" className="autocomplete-items">
                {filteredItems.map((item, index) => {
                  let style = item.enabled
                    ? {}
                    : {
                        pointerEvents: "none",
                        opacity: 0.6,
                      };

                  return (
                    <li
                      key={item.id}
                      onClick={(e) => {
                        selectValue(item);
                      }}
                      style={{ ...style }}
                    >
                      {item.option?.kind === "prod" && (
                        <span
                          className="badge text-bg-warning"
                          style={{ marginRight: "10px" }}
                        >
                          PROD
                        </span>
                      )}
                      {item.option?.kind === "paq" && (
                        <span
                          className="badge text-bg-info"
                          style={{ marginRight: "10px" }}
                        >
                          PAQ
                        </span>
                      )}
                      {item.words.map((word, index) => {
                        const newId = index; //`${item.id}_`;
                        const text = word.text;
                        return (
                          <span key={newId}>
                            {word.isBold && <strong>{text}</strong>}
                            {!word.isBold && <span>{text}</span>}
                          </span>
                        );
                      })}

                      <input type="hidden" value={item.value} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
      </>
    );
  },
);

export default AutocompleteGo;
